import { SitemapPagesGridView } from '~/components/system/sitemap-pages';
import { PageContainer } from '~/components/page-container';

export function SitemapPages() {
	return (
		<PageContainer>
			<SitemapPagesGridView />
		</PageContainer>
	);
}
